if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {

    constructor() {
      super();
    }

    get url() {
      return this.dataset.url;
    }

    connectedCallback() {
      if (this.observer) return; // Prevent double observation

      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    handleIntersection(entries) {
      if (!entries[0].isIntersecting) return;

      // Element may already be removed, disconnect is safe even on unobserved targets

      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
